module.exports = __webpack_public_path__ + "7ef3c8b7333dccc81b8e91f2f727f30c.jpg";